import { useEffect, useId, useState } from 'react';

import { paths } from '@farmersdog/constants';
import {
  GridContainer,
  Button,
  Text,
  type TextVariant,
  useViewport,
} from '@farmersdog/corgi-x';

import { TextTypeRenderer } from '../../../components/TextTypeRenderer';
import { SliceType, EmailFormSlice, isSliceOfType } from '../../../slices';

import styles from './FreshDogFood.css';

import type { BreedDocument } from '../types';

export interface FreshDogFoodProps {
  document: BreedDocument;
}

export function FreshDogFood({ document }: FreshDogFoodProps) {
  const id = useId();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const emailFormSlice = document.data.body.find(
    isSliceOfType(SliceType.EmailFormSlice)
  );

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-72'
    : 'heading-52';

  const linkCopy = emailFormSlice
    ? emailFormSlice.primary.formCta
    : 'Start Feeding Fresh';

  return (
    <section aria-labelledby={id} className={styles.section}>
      <GridContainer className={styles.grid}>
        <Text
          className={styles.title}
          color="kale-3"
          variant={titleVariant}
          weight="bold"
          as="h1"
          id={id}
        >
          Fresh Food for {document.data.title}
        </Text>
        <div className={styles.description}>
          <TextTypeRenderer nodes={document.data.description} />
        </div>
        {emailFormSlice && (
          <div className={styles.form}>
            <EmailFormSlice slice={emailFormSlice} />
          </div>
        )}
        <div className={styles.cta}>
          <Button
            type="anchor"
            href={paths.PATH_SIGNUP}
            className={styles.buttonLink}
          >
            {linkCopy}
          </Button>
        </div>
      </GridContainer>
    </section>
  );
}
